import { render, staticRenderFns } from "./LeadMatchesModal.vue?vue&type=template&id=697d857c&scoped=true"
import script from "./LeadMatchesModal.vue?vue&type=script&lang=js"
export * from "./LeadMatchesModal.vue?vue&type=script&lang=js"
import style0 from "./LeadMatchesModal.vue?vue&type=style&index=0&id=697d857c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d857c",
  null
  
)

export default component.exports